/**
 * entry fill for production without Hot Module Reloading (HMR)
 */

import app from './app/'; // eslint-disable-line import/no-useless-path-segments

app();
